/* eslint-disable */
export default {
  cancel: 'キャンセル',
  confirm: '確認',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
